import { render } from "./MathsTestResultItem.vue?vue&type=template&id=085915e4&scoped=true&ts=true"
import script from "./MathsTestResultItem.vue?vue&type=script&lang=ts"
export * from "./MathsTestResultItem.vue?vue&type=script&lang=ts"

import "./MathsTestResultItem.vue?vue&type=style&index=0&id=085915e4&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085915e4"]])

export default __exports__